import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../ui/services/auth/auth.service';

export const redirectUnauthorizedToLogin: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.authStateReady();
  return authService.currentUser() ? true : router.createUrlTree(['login']);
};

export const redirectLoggedIn: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.authStateReady();
  return authService.currentUser() ? router.createUrlTree(['/']) : true;
};
